import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=1aab71cd&scoped=true&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aab71cd",
  null
  
)

component.options.__file = "Terms.vue"
export default component.exports